import { isNonEmptyString } from '../utils/isNonEmptyString.js';
import { isNumber } from '../utils/isNumber.js';

/**
 * Checks if value is a valid JSON-RPC identifier.
 * Must be a number or a non-empty string.
 * @param {*} value
 * @returns {Boolean}
 */
function isValidId(value) {
    return isNumber(value) || isNonEmptyString(value);
}

export { isValidId };
